import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useLazyQuery } from "@apollo/client";
import { CircularProgress, Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { GET_EDIT_ACCOUNT_SETTINGS } from "../../../graphql/queries";
import AccountSettingsReadOnly from "../../common/AccountSettingsReadOnly";
import AccountSettings from "./AccountSettings";

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.common.white,
  },
}));

const AccountSettingsViewSelector = ({
  accountSettings,
  onError,
  onSaved,
  setAccountSettings,
}) => {
  const classes = useStyles();
  const [isViewedAs, setIsViewedAs] = useState(false);

  const [getEditAccountSettings, { data, error, loading }] = useLazyQuery(
    GET_EDIT_ACCOUNT_SETTINGS
  );

  useEffect(() => {
    getEditAccountSettings();
  }, []);

  useEffect(() => {
    if (
      data &&
      data.userAccountContext &&
      data.userAccountContext.editAccountSettings
    ) {
      setAccountSettings(data.userAccountContext.editAccountSettings);
    }
  }, [data]);

  useEffect(() => {
    if (error) {
      console.info("** failed to get account settings");
      onError?.();
    }
  }, [error]);

  return (
    <div className={classes.root}>
      {error && (
        <Grid container justifyContent="center">
          <FormattedMessage id="userAccount.errors.genericError" />
        </Grid>
      )}
      {loading && !error && (
        <Grid container justifyContent="center">
          <CircularProgress size={30} />
        </Grid>
      )}
      {!loading && !error && (
        <>
          {!isViewedAs && (
            <AccountSettings
              accountSettings={accountSettings}
              onSaved={onSaved}
              setAccountSettings={setAccountSettings}
              setIsViewedAs={setIsViewedAs}
            />
          )}
          {isViewedAs && (
            <AccountSettingsReadOnly
              onClosePreview={() => setIsViewedAs(false)}
              onDirectMessageRequest={undefined}
              userDetails={accountSettings}
            />
          )}
        </>
      )}
    </div>
  );
};

export default AccountSettingsViewSelector;
